import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import {
    ANIMATION_BIGGER,
    ANIMATION_SMALLER,
    conditionalScaleAnimation
} from 'libs/styles/animations';
import { EColors } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const QuickExpand = (props: Props): JSX.Element => {
    return (
        <motion.div {...conditionalScaleAnimation(true, ANIMATION_BIGGER, ANIMATION_SMALLER)}>
            <S_QuickExpand className={props.className}>
                <S_Open icon={['fal', 'arrows-up-down']} />
            </S_QuickExpand>
        </motion.div>
    );
};

const S_QuickExpand = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const S_Open = styled(FontAwesomeIcon)`
    font-size: 20px;
    color: ${EColors.DARK};
`;
